var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.business.photo)?_c('div',[_c('img',{staticStyle:{"height":"150px"},attrs:{"src":_vm.business.photoUrl}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }